import axios from 'axios';
import { getContentProvider } from '@/helper/auth';

export const loadMediaContents = mediaPageLink => axios.get(mediaPageLink);

export const fetchMediaContents = (params) => {
    const { key } = getContentProvider();
    return axios.get(`/cms/${key}/programs/media_contents`, { params });
};

export const getTranscodingProgress = (selectedIds) => {
    const { key } = getContentProvider();

    return axios.post(`/cms/${key}/programs/media_contents/transcoding_percent`, {
        selecteds: selectedIds,
    });
};
